export default __webpack_public_path__ + "static/relatedBg-4f3d2e9a9ce3bf2e89949bea096d9df9.svg";